import { ShieldX } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useLogout } from '@/features/auth/hooks/use-auth'
import { msalInstance } from '@/lib/auth/msal'

/**
 * Shown when Entra signed someone in but the portal has no record for them.
 * Sending them back to the sign-in page would only loop: they can sign in
 * perfectly well, they simply have no place here yet.
 */
export default function NoAccessPage() {
  // Straight from MSAL: there is no portal profile to read an email from, that
  // being the whole problem.
  const email = msalInstance?.getActiveAccount()?.username
  const logout = useLogout()

  return (
    <main className="flex min-h-svh items-center justify-center px-4">
      <div className="w-full max-w-md space-y-4 text-center">
        <ShieldX className="text-muted-foreground mx-auto size-10" aria-hidden />

        <div className="space-y-1">
          <h1 className="font-display text-heading">No access to TQ Capacity</h1>
          <p className="text-muted-foreground text-body">
            You are signed in to Microsoft{email ? ` as ${email}` : ''}, but this account has not
            been given access to the portal. Ask an administrator for an invitation.
          </p>
        </div>

        <Button variant="outline" disabled={logout.isPending} onClick={() => logout.mutate()}>
          Sign out
        </Button>
      </div>
    </main>
  )
}
